import { render, staticRenderFns } from "./BusinessTerms.vue?vue&type=template&id=900d7df0&scoped=true&"
import script from "./BusinessTerms.vue?vue&type=script&lang=js&"
export * from "./BusinessTerms.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTerms.vue?vue&type=style&index=0&id=900d7df0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900d7df0",
  null
  
)

export default component.exports